import Vue from "vue";
import Router from "vue-router";
import store from ".././vuex/store";
import routers from "./routers";
import { Notify } from "vant";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: routers,
});

/**
 * role 0 为普通用户，目前没有其他角色；
 * keepAlive 为是否缓存页面，默认为false 不缓存
 */

// 导航钩子，全局钩子
router.beforeEach((to, from, next) => {
    // 登录页面
    // console.log(from)
    if (to.meta.title) {
        window.document.title = to.meta.title;
	}
	next()
    //
    // if (store.getters.token === "" && to.meta.requiresAuth) {
    //     // Notify('请先登录');
    //     next("/home/index");
    // } else if (store.getters.token !== "" && to.name === "login") {
    //     if (store.getters.role == 1) {
    //         next("/home/index"); // 当前没用到
    //     } else if (store.getters.role == 0) {
    //         next("/home/index");
    //     }
    // } else {
    //     if (to.name == "changepassword" || to.name == "noaccess") {
    //         next();
    //     } else {
    //         if (store.getters.role == 1 && to.meta.role != 1) {
    //             next("/shop/index"); // 当前没用到
    //         } else if (store.getters.role == 0 && to.meta.role != 0) {
    //             next("/home/index");
    //         } else {
    //             // 管理员 活动
    //             // if ( from.name == 'manage-index' && to.name == 'manage-activity-index' ) {
    //             //     to.meta.keepAlive = true
    //             // } else if ( from.name == 'manage-index' && to.name == 'manage-activity-index' ) {
    //             //     to.meta.keepAlive = false
    //             // } else {
    //             //     to.meta.keepAlive = false
    //             // }
    //             next();
    //         }
    //     }
    // }
});
router.afterEach((to) => {});

export default router;
